import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import { ACTION } from 'app/ducks/transactions/collections/actions';
import CollectionsTransactions from './CollectionsTransactions';

const getFilteredCollections = state => {
    return state.transactions.collections.data;
};

const enhancers = [
    connect(
        state => ({
            collections: state.transactions.collections,
            filteredCollections: getFilteredCollections(state),
            automatonFilterValues: state.automatons.filterValues,
            mastersFilterValues: state.masters.filterValues
        }),
        dispatch => ({
            actions: bindActionCreators(ACTION, dispatch),
        })
    )
];

export default compose(...enhancers)(CollectionsTransactions);
